import React from "react";
import DocumentsView from "./DocumentsView";

export function DocumentsContainer() {
  return <DocumentsView title="Documents" />;
}
